module.exports = __webpack_public_path__ + "static/media/hot_price.8f621f9c.png";